import { Controller } from '@hotwired/stimulus';

/**
 * Thread message row when file upload flag is off: keep submit disabled until the body has non-whitespace text.
 * (Upload-on path uses ai-chat-attachments, which also allows file-only sends.)
 * Not used when course_builder wires the same controls to course-builder-ai-modal — see _form.html.erb.
 */
export default class extends Controller {
  static targets = ['content', 'submitButton'];

  connect() {
    this.contentTarget.addEventListener('input', this.sync);
    this.contentTarget.addEventListener('keydown', this.boundKeydown);
    this.sync();
  }

  disconnect() {
    this.contentTarget.removeEventListener('input', this.sync);
    this.contentTarget.removeEventListener('keydown', this.boundKeydown);
  }

  boundKeydown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter' && !this.contentTarget.value.trim()) {
      e.preventDefault();
    }
  };

  sync = () => {
    const ok = Boolean(this.contentTarget.value.trim());
    this.submitButtonTarget.disabled = !ok;
    this.submitButtonTarget.style.opacity = ok ? 1 : 0.5;
  };
}
